module.exports = __webpack_public_path__ + "static/media/covidIcon.16df69cc.svg";